/**
 * Ícones de símbolo por seção INP (`chave`). Onde há ícone, a camada é
 * representada por um símbolo no mapa em vez de cor — e o swatch de cor some do
 * painel. Fonte única pro mapa (usa a URL) e pro painel (usa as chaves), pra não
 * divergirem. Reutilizável: um ponto de KML/outro mapa pode apontar pros mesmos
 * arquivos. Os `.svg` viram URL no import (file/url-loader do vue-cli).
 */

import reservatorio from '@/assets/map/icones/reservatorio.svg'
import valvula from '@/assets/map/icones/valvula.svg'

export const ICONE_POR_CHAVE = {
  valves: valvula,
  reservoirs: reservatorio,
}

// Seções onde o ícone SUBSTITUI a cor (a geometria vira só símbolo — ex.: nó/
// ponto): o swatch some e o ícone vira legenda. As demais com ícone (ex.: válvula
// = linha + símbolo no meio) MANTÊM a cor, porque a aresta ainda é colorida.
const CHAVES_SO_ICONE = new Set(['reservoirs'])

export function chaveUsaIcone(chave) {
  return Object.prototype.hasOwnProperty.call(ICONE_POR_CHAVE, chave)
}

export function chaveSoIcone(chave) {
  return CHAVES_SO_ICONE.has(chave)
}
